import { render, staticRenderFns } from "./FormDinamicCorreo.vue?vue&type=template&id=484636e0"
import script from "./FormDinamicCorreo.vue?vue&type=script&lang=js"
export * from "./FormDinamicCorreo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports